import React, { useRef, useState, useEffect } from "react";
import ApiButton from "./zip-modal-button";

export default function ZipModal({
  slideRoom,
  visibleActors,
  showModal,
  screen,
}: {
  slideRoom: Record<string, any>;
  visibleActors: any;
  showModal: boolean;
  screen: "screen" | "full";
}) {
  // options, title
  const { OptionID, Titel } = slideRoom;

  // zip modal
  const [zipModal, setZipModal] = useState<boolean>(true);
  const emailRef = useRef(null);
  const [emailList, setEmailList] = useState<Array<String>>([]);
  const [pdfChecked, setPdfChecked] = useState(false);
  const [videoChecked, setVideoChecked] = useState(false);
  const [polasChecked, setPolasChecked] = useState(false);

  const addEmails = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === " " || (e.key === "Enter" && emailRef.current.value !== "")) {
      setEmailList([...emailList, emailRef.current.value]);
      emailRef.current.value = " ";
    }
  };

  useEffect(() => {
    setZipModal(!zipModal);
  }, [showModal]);

  return (
    <>
      {zipModal && (
          <div
              className={`flex ${
                  screen === "screen" ? "w-screen" : "w-full"
              } h-screen border justify-center items-center absolute z-10 bg-gray-800 bg-opacity-50 overflow-y-auto p-4 mt-24`}
          >
              <div className="relative w-11/12 sm:w-3/4 lg:w-1/2 max-w-2xl h-auto mx-auto z-20 bg-white rounded-md shadow-lg p-4 md:p-6">
                  {/* Close button */}
                  <button
                      className="absolute top-2 right-2 text-xl font-bold p-2"
                      onClick={() => setZipModal(false)}
                  >
                      ✕
                  </button>

                  <div className="text-center my-6 md:my-10">
                      <h1 className="text-xl md:text-2xl font-semibold">Download Area</h1>
                      <hr className="w-16 mx-auto mt-4" />

                      <p className="mt-4 text-sm md:text-base font-light px-2">
                          Get the list of the selected actors as PDFs and optional with the videos as a zip format per email.
                      </p>

                      {/* Email list + input */}
                      <div className="mt-6 w-full md:w-3/4 mx-auto">
                          <p className="text-center text-sm">Email(s):</p>

                          <div className="flex flex-row flex-wrap gap-1 my-3 justify-center">
                              {emailList.map((e) => (
                                  <span
                                      className="text-xs border border-gray-300 text-gray-600 py-1 px-2 rounded-sm"
                                      key={Math.random()}
                                  >
              {e}
            </span>
                              ))}
                          </div>

                          <input
                              type="email"
                              defaultValue={emailRef?.current?.value}
                              ref={emailRef}
                              placeholder="max@mustermann.de"
                              className="border border-gray-300 rounded-sm w-full text-center text-sm py-2 px-3"
                              onChange={(e) => (emailRef.current.value = e.target.value)}
                              onKeyDown={(e) => addEmails(e)}
                          />

                          <p className="text-center text-xs font-light mt-1">
                              Hint: Press <span className="font-semibold">SPACE or ENTER</span> to confirm.
                          </p>
                      </div>

                      {/* Checkboxes + button */}
                      <div className="flex flex-col justify-center items-center mt-6 space-y-2">
                          <label className="flex flex-row items-center text-sm">
                              <input
                                  type="checkbox"
                                  className="mr-2"
                                  defaultChecked={pdfChecked}
                                  onChange={() => setPdfChecked(!pdfChecked)}
                              />
                              SetCard (PDF)
                          </label>

                          <label className="flex flex-row items-center text-sm">
                              <input
                                  type="checkbox"
                                  className="mr-2"
                                  defaultChecked={videoChecked}
                                  onChange={() => setVideoChecked(!videoChecked)}
                              />
                              Videos (if available)
                          </label>

                          <label className="flex flex-row items-center text-sm">
                              <input
                                  type="checkbox"
                                  className="mr-2"
                                  defaultChecked={polasChecked}
                                  onChange={() => setPolasChecked(!polasChecked)}
                              />
                              Polas (if available)
                          </label>

                          <ApiButton
                              OptionID={OptionID}
                              Titel={Titel}
                              pdfChecked={pdfChecked}
                              slideRoom={slideRoom}
                              videoChecked={videoChecked}
                              visibleActors={visibleActors}
                              emailList={emailList}
                              emailState={setEmailList}
                              polasChecked={polasChecked}
                          />
                      </div>
                  </div>
              </div>
          </div>
      )}
    </>
  );
}
